import { SearchResponse } from "../../../types";
import { useQuery } from "@tanstack/react-query";
import { searchApi } from "../../../api/resources.api";



export const useSearch = (query: string) => {
  return useQuery<SearchResponse, Error>({
    queryKey: ["search", query],
    queryFn: async () => {
      const trimmedQuery = query.trim();
      if (!trimmedQuery) {
        throw new Error("Search query is empty");
      }
      const response = await searchApi(trimmedQuery);
      if (!response || typeof response !== "object" || !("results" in response)) {
        throw new Error("Invalid search response");
      }
      return response as SearchResponse;
    },
    enabled: Boolean(query.trim()),
    staleTime: 1000 * 60,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
